<template>
  <calendar v-model="inputValue" v-bind="$props" @keyup="onKeyup"></calendar>
</template>

<script setup lang="ts">
import Calendar from 'src/components/lib/Calendar/index.vue';
import { calendarDefaults } from 'src/consts/calendar';
import {
  onMounted,
  watch,
  reactive,
  computed,
} from 'vue';
import { dtFormat, ensureDate } from 'src/lib/dateHelper';

interface MyCalenderState {
  isDateValueSet: boolean;
  dateValue: Date | null;
}

// withDefaultsでdefaultを与えても、TS上optional(?)でないとrequired:trueのままになるVueの仕様
// https://github.com/vuejs/core/blob/v3.5.35/packages/compiler-sfc/src/script/resolveType.ts (required: !e.optional)
// defaultを持つ以下のpropsは全てoptionalにしている
interface Props {
  dateValue?: Date;
  format?: string;
  inputClassObj?: Record<string, string>;
  inputClearButton?: boolean;
  clearButton2Disabled?: boolean;
  readonly?: boolean;
  placeholder?: string;
  lang?: string;
  pane?: number;
  dayHeaderFormat?: string;
  disableSwitchMonthView?: boolean;
  onDayClick?: (date: Date, dateString: string) => void;
  changePane?: (year: number, month: number, pane: number) => void;
  dateInputBgColor?: string;
  setDateValueOnce?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  format: calendarDefaults.format,
  inputClassObj: () => ({}),
  inputClearButton: calendarDefaults.inputClearButton,
  clearButton2Disabled: false,
  readonly: calendarDefaults.readonly,
  lang: calendarDefaults.lang,
  pane: calendarDefaults.pane,
  dayHeaderFormat: calendarDefaults.dayHeaderFormat,
  disableSwitchMonthView: calendarDefaults.disableSwitchMonthView,
  onDayClick: () => () => { },
  changePane: () => () => { },
  setDateValueOnce: true,
});

const emit = defineEmits(['date-input', 'keyup']);

const state = reactive<MyCalenderState>({
  isDateValueSet: false,
  dateValue: props.dateValue ?? null,
});

const trySetDateValue = () => {
  if (!props.dateValue) return;
  if (props.setDateValueOnce && state.isDateValueSet) return;

  state.isDateValueSet = true;
  state.dateValue = props.dateValue;
};
onMounted(trySetDateValue);

watch(() => props.dateValue, trySetDateValue);

const inputValue = computed<string>({
  get: () => {
    if (!state.dateValue) return '';

    return dtFormat(new Date(state.dateValue), props.format);
  },
  set: (val: string) => {
    let dt = ensureDate(val);
    if (dt && (val && val.length === props.format.length)) {
      // 桁数が正常かつdtが正常なら、その時点で同期しておく
      state.dateValue = dt;
    }
    emit('date-input', dt);
  },
});

const onKeyup = ($event: KeyboardEvent) => {
  emit('keyup', $event);
};
</script>
